export const getAgeFromDateOfBirth = dateOfBirth =>
  dateOfBirth
    ? Math.round(
        (Date.now() - dateOfBirth) / 1000 / 60 / 60 / 24 / 365
      ).toString()
    : '';
